<app-authentication-container>
  <app-merchant-registration-form
    [errorResponse]="errorResponse$ | async"
    [isLoading]="isLoading$ | async"
    (continue)="onContinue($event)"
  ></app-merchant-registration-form>
</app-authentication-container>
